import Tingle from 'tingle.js';
window.addEventListener('load', () => {
    const modal = new Tingle.modal({
        closeLabel: '',
        beforeClose: () => {
            const contentEl = modal.getContent();
            // モーダルをさかのぼってモーダルルート要素を取得
            const modalEl = contentEl.parentElement?.parentElement;
            const classNameLeave = 'leave';
            if (modalEl) {
                if (modalEl.classList.contains(classNameLeave)) {
                    modalEl.removeEventListener('animationend', hideModal);
                    modalEl.classList.remove(classNameLeave);
                    return true;
                }
                else {
                    modalEl.addEventListener('animationend', hideModal);
                    modalEl.classList.add(classNameLeave);
                }
            }
            return false;
        },
        onOpen: () => {
            const contentEl = modal.getContent();
            const boxEl = contentEl.parentElement;
            if (boxEl) {
                boxEl.addEventListener('click', hideModal);
            }
        },
        onClose: () => {
            const contentEl = modal.getContent();
            const boxEl = contentEl.parentElement;
            if (boxEl) {
                boxEl.removeEventListener('click', hideModal);
            }
        }
    });
    const hideModal = () => modal.close();
    window.showCharaModal = (el) => {
        const img = document.createElement('img');
        img.src = el.dataset.image;
        // 画像クリックの伝播を停止
        img.addEventListener('click', evt => {
            evt.stopPropagation();
        });
        modal.setContent(img);
        modal.open();
    };
});
